<template>
  <el-dialog :visible.sync="visible"
             title="选择收件人"
             width="900px"
             custom-class="dialog"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form label-position="top"
             :inline="true">
      <el-row class="margb10">
        <el-col :span="6"
                class="padt5">
          <!-- 用户名称 -->
          <el-form-item label="用户名称">
            <el-input :placeholder="$t('user.input')"
                      v-model="dataForm.userName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="padt5">
          <!-- 经销商代码 -->
          <el-form-item label="公司名称">
            <el-select clearable
                       remote
                       filterable
                       reserve-keyword
                       :placeholder="$t('user.input')"
                       v-model="dataForm.orgCode"
                       :remote-method="orgQuerySearch"
                       @change="orgChange">
              <el-option v-for="item in orgList"
                         :key="item.orgCode"
                         :label="item.name"
                         :value="item.orgCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="padt5">
          <!-- 职位 -->
          <el-form-item label="职位">
            <el-select remote
                       filterable
                       v-model="dataForm.jobCode"
                       reserve-keyword
                       clearable
                       :disabled="jobCodeShow"
                       :placeholder="$t('selectOrgId')"
                       :remote-method="querySearch">
              <el-option v-for="item in jobCodeList"
                         :key="item.positionCode"
                         :label="item.positionName"
                         :value="item.positionCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4"
                style="float:right">
          <!-- 查询 -->
          <el-col :span="24">
            <el-button class="M-search"
                       style="margin-bottom: 7px"
                       @click="search()"
                       type="primary">{{$t('user.query')}}</el-button>
          </el-col>
          <!-- 重置 -->
          <el-col :span="24">
            <el-button class="el-back M-search M-margin-l"
                       type="info"
                       @click="again">{{$t('reset')}}</el-button>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
    <div class="search">
      <!-- 保存 -->
      <el-button class="el-button-columnBtn"
                 @click="usersave()">确定</el-button>
    </div>
    <div class="table-user table"
         style="margin-top:8px; overflow:hidden">
      <el-table :data="dataList"
                v-loading="dataListLoading"
                border
                ref="dataList"
                @selection-change="selectionUserHandle"
                :header-cell-style="{height:'20px'}"
                height="300px"
                style="width: 100%">
        <el-table-column type="selection"
                         header-align="center"
                         align="center"
                         width="50"
                         :reserve-selection="true">
        </el-table-column>
        <!-- 用户ID -->
        <el-table-column prop="userCode"
                         label="用户ID"
                         show-overflow-tooltip
                         align="left"
                         header-align="center">
        </el-table-column>
        <!-- 中文名称 -->
        <el-table-column prop="userName"
                         label="中文名称"
                         show-overflow-tooltip
                         align="left"
                         header-align="center">
        </el-table-column>
        <!-- 品牌 -->
        <el-table-column prop="brandCode"
                         :formatter="orgTypeFormatter"
                         label="品牌"
                         show-overflow-tooltip
                         align="left"
                         header-align="center">
        </el-table-column>
        <!-- 网点类型 -->
        <el-table-column prop="networkType"
                         label="网点类型"
                         show-overflow-tooltip
                         align="left"
                         :formatter="outletFormatter"
                         header-align="center">
        </el-table-column>
        <!-- 经销商代码NSC -->
        <el-table-column prop="nscNo"
                         label="经销商代码NSC"
                         show-overflow-tooltip
                         align="left"
                         header-align="center">
        </el-table-column>
        <!-- 公司名称 -->
        <el-table-column prop="name"
                         label="公司名称"
                         show-overflow-tooltip
                         align="left"
                         width="150"
                         header-align="center">
        </el-table-column>
        <!-- 邮箱 -->
        <el-table-column prop="email"
                         label="邮箱"
                         show-overflow-tooltip
                         align="left"
                         header-align="center">
        </el-table-column>
        <!-- 职位 -->
        <el-table-column prop="positionName"
                         label="职位"
                         show-overflow-tooltip
                         align="left"
                         header-align="center">
        </el-table-column>
        <!-- 状态 -->
        <el-table-column prop="jobStatus"
                         label="状态"
                         show-overflow-tooltip
                         align="left"
                         header-align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.jobStatus === '10'">{{$t('user.move')}}</span>
            <!-- 不活动 -->
            <span v-if="scope.row.jobStatus === '20'">{{$t('user.unmove')}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block"
           style="float: right;margin-top: 5px;margin-right: 30px; margin-bottom: 5px">
        <el-pagination @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle"
                       :current-page="page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limit"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: `/sys/commmail/mailReceiverList`,
        getDataListIsPage: true
      },
      // // 品牌
      brandCode: _this.enums['brandCode'],
      // 网点类型
      networkType: _this.enums['networkType'],
      visible: false,
      dataForm: {
        orgId: '',
        orgCode: '',
        userName: '',
        jobCode: ''
      },
      // 职位的只读
      jobCodeShow: true,
      dataList: [],
      dataListSelections: [],
      dataListLoading: false,
      page: 1,
      limit: 10,
      mailId: '',
      jobCodeList: [],
      orgList: []
    }
  },
  methods: {
    // 回显
    orgTypeFormatter(row) {
      // 品牌
      return Vue.filter('coverEnumList')(row.brandCode, 'brandCode', ',')
    },
    outletFormatter(row) {
      // 网点
      return Vue.filter('coverEnum')(row.networkType, 'networkType')
    },
    orgChange() {
      if (this.dataForm.orgCode !== '' && this.dataForm.orgCode !== null && this.dataForm.orgCode !== undefined) {
        this.jobCodeShow = false
      } else {
        this.jobCodeShow = true
        this.dataForm.jobCode = ''
      }
    },
    // 选择收件人
    selectionUserHandle(val) {
      this.dataListSelections = val
      console.log(this.dataListSelections)
    },
    // 选择职位的list
    querySearch(queryString) {
      console.log(queryString)
      this.$request.get('/sys/commmail/queryPositionName',
        {
          positionName: queryString,
          orgCode: this.dataForm.orgCode
        }).then((res, total, code, data) => {
          this.jobCodeList = res
          console.log(this.jobCodeList)
        }).catch((err) => {
          console.log(err)
        })
    },
    // 选择经销商list
    orgQuerySearch(orgQuery) {
      console.log(orgQuery)
      this.$request.get('/sys/commmail/queryOrgName',
        {
          name: orgQuery
        }).then((res, total, code, data) => {
          this.orgList = res
          console.log(this.orgList)
        }).catch((err) => {
          console.log(err)
        })
      console.log(this.dataList)
    },
    // 确定收件人
    usersave(id) {
      let params = id ? [id] : this.dataListSelections.map(item => {
        return item.userId
      })
      console.log(params)
      if (params === '' || params === null || params === undefined || params === []) {
        this.$confirm(this.$t('mailUser'), this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          center: true
        }).then((res) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.$request.post(`/sys/commmail/saveReceiver`,
          {
            mailId: parseInt(this.mailId, 10),
            userIds: params + ''
          }
        ).then(() => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.visible = true
              this.$emit('refreshDataList')
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    getUserList() {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.result
        this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.total : 0
        for (let y = 0; y < this.dataList.length; y++) {
          for (let i = 0; i < this.dataListSelections.length; i++) {
            if (this.dataList[y].userId === this.dataListSelections[i].userId) {
              this.$refs.dataList.toggleRowSelection(this.dataList[y], true)
            }
          }
        }
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    init(mailId) {
      this.jobCodeShow = true
      this.mailId = mailId
      this.dataListSelections = []
      this.dataForm.orgCode = ''
      this.dataForm.userName = ''
      this.dataForm.jobCode = ''
      this.dataForm.mailId = mailId
      console.log(this.mailId)
      this.visible = true
      this.getUserList()
    },
    // 重置
    again() {
      this.dataForm = {
        orgId: '',
        orgCode: '',
        userName: '',
        jobCode: ''
      }
      this.page = 1
      this.jobCodeShow = true
      this.dataForm.mailId = this.mailId
      this.getUserList()
    },
    search() {
      this.page = 1
      this.dataForm.mailId = this.mailId
      this.getUserList()
    },
    pageCurrentChangeHandle(val) {
      this.page = val
      this.getUserList()
      console.log(this.dataList)
      console.log(this.dataListSelections)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
  height: 500px !important;
  width: 800px !important;
}
.dialog {
  height: 500px;
}
.el-select-dropdown {
  max-width: 200px !important;
}
</style>
